import { DateAdapter } from "@/infrastructure/adapters/dayJs";
import { RemittanceItem, RemittanceItemProps } from "./RemittanceItem";
import { DateService, NumberFormatterService } from "@/core/services";
import { NumberFormatterAdapter } from "@/infrastructure/adapters/number";
import { NumberFormatType } from "@/core/types";
import { Purchaser, PurchaserProps } from "@/core/entities/lookup";

export interface RemittanceProps {
  remittanceId: number;
  checkNo: string;
  checkDate: string;
  checkAmount: number;
  purchaser: PurchaserProps;
  deductedAmount: number;
  isNew: boolean;
  remittanceItems: RemittanceItemProps[];
}

export class Remittance {
  private readonly _remittanceId: number;
  private readonly _checkNo: string;
  private readonly _checkDate: string;
  private readonly _checkAmount: number;
  private readonly _purchaser: PurchaserProps;
  private readonly _deductedAmount: number;
  private readonly _isNew: boolean;
  private _remittanceItems: RemittanceItemProps[];

  constructor(props: RemittanceProps) {
    this._remittanceId = props.remittanceId;
    this._checkNo = props.checkNo;
    this._checkDate = props.checkDate;
    this._checkAmount = props.checkAmount;
    this._purchaser = props.purchaser;
    this._deductedAmount = props.deductedAmount;
    this._isNew = props.isNew;
    this._remittanceItems = props.remittanceItems;
  }

  get key(): number {
    return this._remittanceId;
  }

  get remittanceId(): number {
    return this._remittanceId;
  }

  get checkNumber(): string {
    return this._checkNo;
  }

  get checkDate(): string {
    return this._checkDate;
  }

  public checkDateFormatted(format: string): string {
    return new DateService(new DateAdapter()).format(this._checkDate, format);
  }

  get checkAmount(): number {
    return this._checkAmount;
  }

  public checkAmountFormatted(format: NumberFormatType): string {
    return new NumberFormatterService(new NumberFormatterAdapter()).format(this._checkAmount, format);
  }

  get purchaser(): PurchaserProps {
    return new Purchaser(this._purchaser);
  }

  get deductedAmount(): number {
    return this._deductedAmount;
  }

  public deductedAmountFormatted(format: NumberFormatType): string {
    return new NumberFormatterService(new NumberFormatterAdapter()).format(this._deductedAmount, format);
  }

  get isNew(): boolean {
    return this._isNew;
  }

  get remittanceItems(): RemittanceItem[] {
    return this._remittanceItems.map(item => new RemittanceItem(item));
  }

  set remittanceItems(remittanceItems: RemittanceItemProps[]) {
    this._remittanceItems = remittanceItems;
  }
}
